import SubscribeDriver from './activation/SubscribeDriver';
import { DashboardPaymentNoticesProvider } from './DashboardPaymentNotices';
import { isRouterMerchantSeedPendingHydration } from './shared/preFormInviteComplete';
import {
  shouldShowSubscribeStep,
  getOnboardingSubscribeIntent,
} from './shared/subscribeStepComplete';
import { useLocation } from 'react-router-dom';
import DashboardRouteFallback from '../../components/loading/DashboardRouteFallback';
import { DashboardHeaderSkeleton } from '../../components/loading/DashboardShellSkeleton';
import { EmptyState } from '../../components/ui/empty-state';

export default function DashboardOnboardingChrome({
  merchant,
  setMerchant,
  stripeConnectInstance,
  merchantHydrationEnabled = true,
  merchantHydrationStatus,
  onRetryMerchant,
  children,
}) {
  const { pathname } = useLocation();
  const hydrating =
    !pathname.startsWith('/onboarding') &&
    (isRouterMerchantSeedPendingHydration(merchant) || (merchantHydrationEnabled && !merchant));
  const subscribe = !hydrating && shouldShowSubscribeStep(merchant);
  return (
    <div
      data-dashboard-route-content
      className="relative flex min-h-0 min-w-0 flex-1 flex-col overflow-clip bg-paper-muted"
    >
      {hydrating ? (
        <>
          <DashboardHeaderSkeleton />
          {merchantHydrationStatus === 'error' ? (
            <div className="flex flex-1 items-center justify-center" role="alert">
              <EmptyState
                icon={null}
                title="We couldn’t load your organization"
                description="Check your connection and try again."
                actionLabel="Retry"
                onAction={onRetryMerchant}
              />
            </div>
          ) : (
            <DashboardRouteFallback pathname={pathname} />
          )}
        </>
      ) : subscribe ? (
        <SubscribeDriver
          merchant={merchant}
          setMerchant={setMerchant}
          selectedPlan={getOnboardingSubscribeIntent(merchant)}
        />
      ) : (
        <>
          <DashboardPaymentNoticesProvider value={{ merchant, stripeConnectInstance }}>
            <div className="flex min-h-0 min-w-0 flex-1 flex-col">{children}</div>
          </DashboardPaymentNoticesProvider>
        </>
      )}
    </div>
  );
}
